import Vue from 'vue';
import BaseProgressCircular from '../components/base/BaseProgressCircular.vue';
import BaseProgressLinear from '../components/base/BaseProgressLinear.vue';
import BasePaginator from '../components/base/BasePaginator.vue';
import MyAutocompleteMultiple from '../components/form/MyAutocompleteMultiple.vue';

Vue.component('BaseProgressCircular', BaseProgressCircular);
Vue.component('BaseProgressLinear', BaseProgressLinear);
Vue.component('BasePaginator', BasePaginator);
Vue.component('MyAutocompleteMultiple', MyAutocompleteMultiple);
